import { DIBELS8, OLS, OLS_SPANISH, IDEL2 } from './applications';
import { MEASURE_NAMES } from './assessments';
import { GRADE } from './enrollment';

export const DEFAULT_APP_CONFIG = {
    [OLS]: {
        config: {
            measures: [
                {
                    grades: [GRADE.KG, GRADE.ONE, GRADE.TWO, GRADE.THREE, GRADE.FOUR, GRADE.FIVE],
                    measure: MEASURE_NAMES.OL,
                },
            ],
        },
    },
    [OLS_SPANISH]: {
        config: {
            measures: [
                {
                    grades: [GRADE.KG, GRADE.ONE, GRADE.TWO],
                    measure: MEASURE_NAMES.OL,
                },
            ],
        },
    },
    [IDEL2]: {
        config: {
            measures: [
                {
                    grades: [GRADE.ONE, GRADE.TWO, GRADE.THREE, GRADE.FOUR, GRADE.FIVE, GRADE.SIX],
                    measure: MEASURE_NAMES.CP,
                },
                {
                    grades: [GRADE.KG],
                    measure: MEASURE_NAMES.FSLIK,
                    isOptional: true,
                },
                {
                    grades: [GRADE.KG, GRADE.ONE, GRADE.TWO],
                    measure: MEASURE_NAMES.QQ,
                    isOptional: true,
                },
            ],
        },
    },
    [DIBELS8]: {
        config: {
            measures: [
                {
                    grades: [GRADE.KG, GRADE.ONE],
                    measure: MEASURE_NAMES.LNF,
                },
                {
                    grades: [GRADE.KG, GRADE.ONE],
                    measure: MEASURE_NAMES.PSF,
                },
                {
                    grades: [GRADE.KG],
                    measure: MEASURE_NAMES.FSI,
                    is_optional: true,
                },
                {
                    grades: [GRADE.KG, GRADE.ONE, GRADE.TWO, GRADE.THREE],
                    measure: MEASURE_NAMES.NWF,
                },
                {
                    grades: [GRADE.KG, GRADE.ONE, GRADE.TWO, GRADE.THREE],
                    measure: MEASURE_NAMES.WRF,
                },
                {
                    grades: [GRADE.ONE, GRADE.TWO, GRADE.THREE, GRADE.FOUR, GRADE.FIVE, GRADE.SIX],
                    measure: MEASURE_NAMES.ORF,
                },
                {
                    grades: [GRADE.ONE, GRADE.TWO, GRADE.THREE, GRADE.FOUR, GRADE.FIVE, GRADE.SIX],
                    measure: MEASURE_NAMES.MAZE,
                },
            ],
        },
    },
};
